export const columns = [
  {
    title: '编号',
    dataIndex: 'orderno',
  },
  {
    title: '发票状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '开票时间',
    dataIndex: 'invoiceTime',
    slots: { customRender: 'invoiceTime' },
    customRender: (text) => {
      return text === '0001-01-01 00:00:00' ? '' : text;
    },
    width: 200,
  },
  {
    title: '发票类型',
    dataIndex: 'invoiceType',
    slots: { customRender: 'invoiceType' },
    customRender: (text) => {
      return text == '1'
        ? '普通发票'
        : text == '2'
        ? '冲红普通发票'
        : text == '3'
        ? '专用发票'
        : '冲红专用发票';
    },
  },
  {
    title: '操作',
    dataIndex: 'id',
    scopedSlots: { customRender: 'action' },
  },
];
